import type { Role, JiraRoleDescription } from '../../common/types';

export const getDefaultRoleId = (roles: JiraRoleDescription[] | null): number => {
	if (roles) {
		const defaultRole: JiraRoleDescription[] = roles.filter(
			(role: JiraRoleDescription) => role.default,
		);
		if (defaultRole.length > 0) {
			return defaultRole[0].id;
		}
	}
	return -1;
};

export const getAdminRoleId = (roles: JiraRoleDescription[] | null): number => {
	if (roles) {
		const adminRole: JiraRoleDescription[] = roles.filter(
			(role: JiraRoleDescription) => role.admin,
		);
		if (adminRole.length > 0) {
			return adminRole[0].id;
		}
	}
	return -1;
};

export const getRoleFromDetails = (roles: JiraRoleDescription[] | null): Role[] => {
	if (roles) {
		return roles.map(
			(role: JiraRoleDescription): Role => ({
				id: role.id,
				description: role.description,
				name: role.name,
				translatedName: role.translatedName,
			}),
		);
	}
	return [];
};
